export { default } from "./MenuLogoutButton";


// WEBPACK FOOTER //
// ./src/components/MenuLogoutButton/index.js